import React, { useEffect } from "react";
 
import Row from "react-bootstrap/Row";
import styles from "../../../ui/MediaItem.module.scss";
import "react-datepicker/dist/react-datepicker.css";
import { Button, Carousel, Col, Image } from "react-bootstrap";
import API from "../../../../lib/api";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPodcastList } from "../../../../store/mediaMethods";
import { Link, useParams } from "react-router-dom";
import DatePosted from "../../../ui/common/DatePosted";
import VideoPlayer from "../../../ui/VideoPlayer/VideoPlayer";
import AudioPlayer from "react-h5-audio-player";
import MediaItem from "../../../ui/MediaItem";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { BiArrowBack } from "react-icons/bi";
import { AiFillCloseCircle } from "react-icons/ai";
import close from "../../../../styles/SuperAdminPanel.module.scss";
import { playerActions } from "../../../../store/playerSlice";
function ChannelDisplay() {
  const dispatch = useDispatch();
  const params = useParams();
  const slug = params.slug;
  const navigate = useNavigate();
 
  const [channelDetails, setChannelDetails] = useState({});
  const profileData = useSelector((state) => state.auth.myProfile);
  const podcasts = useSelector((state) => state.media.podcast);
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const [isPodcastLoading, setIsPodcastLoading] = useState(false);
  const [podcastList, setPodcastList] = useState([]);
  const [selectedPodcast, setSelectedPodcast] = useState("");
  const [playing, setPlaying] = useState(false);
  const [videoLink, setVideoLink] = useState(false);
  const mediaData = useRef();
  const isPlaying = useSelector((state) => state.player.isPlaying);
 
  useEffect(() => {
    //if (podcasts.length === 0) {
    if (isLoggedIn) {
      setIsPodcastLoading(true);
      dispatch(getPodcastList("limit=15")).then(() =>
        setIsPodcastLoading(false)
      );
    }
    //}
  }, []);
 
  useEffect(() => {
    const handleLocationChange = () => {
      window.location.reload();
    };
 
    window.addEventListener("popstate", handleLocationChange);
 
    return () => {
      window.removeEventListener("popstate", handleLocationChange);
    };
  }, []);
 
  useEffect(() => {
    async function fetchData() {
      try {
        // Get the current URL
        const currentURL = window.location.href;
 
        // Split the URL at the "?" to get the query parameters
        const queryParameters = currentURL.split("=")[1];
 
        // Make an API call using the query parameter
        const chan = await API.get(`/api/podcast/superunit/${queryParameters}`);
        setChannelDetails(chan.data);
        const podcastchannel = await API.post(`/api/podcast/scheduled-unit/`, {
          superunit: queryParameters,
          client: profileData.client_details.uuid,
        });
        console.log(podcastchannel.data, "cast");
        setPodcastList(podcastchannel.data);
        // const indexWithMatch = podcasts.findIndex(
        //   (podcast) => podcast.channel.uuid === queryParameters
        // );
        // if (indexWithMatch !== -1) {
        //   const matchingPodcast = podcasts[indexWithMatch];
        //   console.log(matchingPodcast, "match");
        //   setPodcastList(matchingPodcast);
        // }
      } catch (error) {
        console.error(error);
      }
    }
 
    fetchData();
  }, [params.slug]);
 
  console.log(podcastList);
 
  const handlePodcastClick = () => {
    if (channelDetails !== podcastList?.podcast) {
      setChannelDetails(podcastList?.podcasts);
      console.log(podcastList?.podcast, "chann");
    }
  };
 
  useEffect(() => {
    if (
      channelDetails &&
      channelDetails?.raw_file_origin?.name?.includes("mp3" || "audio/mpeg")
    ) {
      setVideoLink(false);
    } else {
      setVideoLink(true);
    }
  }, [channelDetails, isPlaying, playing]);
  console.log(videoLink, "link");
  console.log(selectedPodcast, "fffss");
 
  return (
    <>
      {console.log(channelDetails, "ddaa")}
      <div className={`${styles.content} container mt-5`}>
        <Button
          className="mt-5 mb-3 float-end"
          style={{ width: "10px" }}
          onClick={() => {
            navigate(-1);
          }}
          // Use navigate(-1) to go back
        >
          <BiArrowBack />
        </Button>{" "}
        <Row className="h-75 mt-5">
          <Col md={4} className="mt-auto mb-5 pb-5">
            <h1 className="h3">{channelDetails.title}</h1>
            {channelDetails.duration ? (
              <div>
                <span className="badge bg-secondary me-2 fw-light">
                  {channelDetails?.duration}
                </span>
                <span className="badge bg-primary fw-light">
                  <DatePosted date={channelDetails?.created_at} format="YYYY" />
                </span>
              </div>
            ) : (
              ""
            )}
            <div className="mb-2">
              <span className="badge bg-primary me-2"></span>
            </div>
            <p>{channelDetails.description}</p>
            {channelDetails?.raw_file_origin ? (
              isPlaying && playing ? (
                <div>
                  <Button
                    onClick={() => {
                      setPlaying(false);
                      dispatch(playerActions.isPlaying(false));
                      setSelectedPodcast("");
                    }}
                  >
                    Stop
                  </Button>
                </div>
              ) : (
                <div>
                  <Button
                    onClick={() => {
                      setPlaying(true);
                      dispatch(playerActions.isPlaying(true));
                      setSelectedPodcast(
                        channelDetails?.raw_file_origin?.url?.split("?")[0]
                      );
                    }}
                  >
                    Play
                  </Button>
                </div>
              )
            ) : (
              ""
            )}
          </Col>
          <Col className="my-4 my-lg-0">
            <div className="ratio ratio-16x9 rounded overflow-hidden shadow bannerHolder">
              {console.log(
                channelDetails.raw_file_origin?.url?.split("?")[0],
                "channel"
              )}
              {videoLink ? (
                <VideoPlayer
                  src={channelDetails.raw_file_origin?.url?.split("?")[0]}
                  placeholder={
                    channelDetails.thumbnail_file_origin?.url?.split("?")[0]
                  }
                />
              ) : (
                <Image
                  className={`${styles.halfImage}`}
                  src={channelDetails.thumbnail_file_origin?.url?.split("?")[0]}
                />
              )}
            </div>
          </Col>
          <Row className="row-cols-2 mt-5 row-cols-md-3 row-cols-lg-5">
            {podcastList.length > 0 &&
              podcastList.map((poddcast, i) => {
                const { channel, podcast } = poddcast;
                {
                  console.log(podcast, "pofd");
                }
                return (
                  <div
                    key={`podcast_${i}`}
                    className="col"
                    onClick={() => {
                      setChannelDetails(podcast);
                      setPlaying(true);
                      console.log(
                        podcast?.raw_file_origin?.type?.includes("mp3"),
                        "Aas"
                      );
                      dispatch(playerActions.isPlaying(true));
                      if (podcast?.raw_file_origin?.type?.includes("mp4")) {
                        setSelectedPodcast(
                          channelDetails.raw_file_origin?.url?.split("?")[0]
                        );
                      }
                    }}
                  >
                    <MediaItem
                      ctaText="Play"
                      type="podcast"
                      mediaData={poddcast}
                      playerType="inline"
                    />
                  </div>
                );
              })}
          </Row>
          {console.log(channelDetails, "details")}
        </Row>
      </div>
    </>
  );
}
 
export default ChannelDisplay;

